import React, { FunctionComponent } from "react"
import { graphql } from "gatsby"
import { MainContent } from "components/commons/commons"
import { MainLayout } from "components/Layout/Layout"
import styled from "styled-components"
import BG from "assets/bg.png"
import BGMOB from "assets/bg-mobile.png"
import { useBreakpoints } from "src/lib/hooks/use-breakpoints"
import { CTASection } from "components/CTA/CTA"
import { ArticleElement } from "components/Article/ArticleElement"
import { colors } from "src/styles/colors"
import "../styles/base.less"
import { ListPagination } from "components/ListPagination/ListPagination"
import { FooterStrip } from "components/Footer/footer-strip"

const ArticleTemplate: FunctionComponent<any> = ({
  data: {
    allContentfulArticle: { edges },
    contentfulArticleCta,
  },
  pageContext,
}) => {
  const { minTablet } = useBreakpoints()
  const articles = edges

  return (
    <MainLayout
      title={"TutorSpace Blog | Für Lehrer, Schüler & Eltern"}
      description={
        "Wir helfen dir bei allem rund um das Thema Schule: Ratgeber, Tipps für bessere Noten und Fallstudien zu relevanten Themen für Lehrer, Schüler & Eltern."
      }
    >
      <MainContent>
        <ArticleList minTablet={minTablet}>
          {articles.map((article: any, idx: number) => (
            <ArticleElement {...article.node} key={idx} />
          ))}
          <ListPagination {...pageContext} />
        </ArticleList>
      </MainContent>
      <Background minTablet={minTablet} src={`url(${minTablet ? BG : BGMOB})`}>
        <MainContent>
          <CTASection {...contentfulArticleCta} />
        </MainContent>
      </Background>
      <MainContent>
        <FooterStrip />
      </MainContent>
    </MainLayout>
  )
}

export default ArticleTemplate

const ArticleList = styled.div<any>`
  padding: ${({ minTablet }) =>
    minTablet ? "48px 0 66px 0" : "32px 0 64px 0"};
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: ${({ minTablet }) => (minTablet ? "row" : "column")};
  & .article {
    margin-right: ${({ minTablet }) => (minTablet ? "24px" : 0)};
    margin-bottom: ${({ minTablet }) => (minTablet ? "70px" : "46px")};
    &:nth-child(3n + 0) {
      margin-right: 0;
    }
  }
`

const Background = styled.div<any>`
  background: ${({ src }) => (src ? src : colors.white)};
  background-repeat: no-repeat;
  background-size: cover;
  min-height: ${({ minTablet }) => (minTablet ? "500px" : "769px")};
  width: 100%;
  height: 100%;
`
export const pageQuery = graphql`
  query blogListQuery($skip: Int!, $limit: Int!) {
    allContentfulArticle(
      sort: { order: DESC, fields: createdAt }
      limit: $limit
      skip: $skip
      filter: { node_locale: { eq: "en-US" } }
    ) {
      edges {
        node {
          slug
          title
          author {
            name
          }
          createdAt(formatString: "DD MMM YYYY", locale: "de")
          subtitle {
            subtitle
          }
          outsideImage {
            fluid(maxWidth: 360, maxHeight: 230, quality: 100) {
              ...GatsbyContentfulFluid_withWebp
            }
          }
        }
      }
    }
    contentfulArticleCta {
      firstText
      secondTest
      firstButtonText
      firstButtonLink
      secondButtonText
      secondButtonLink
    }
  }
`
